<template>
  <div class="sector needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" :title="info.title" :text="info.infoKey" ></Info>
    <div class="sector-title">
      <h3>{{$t(info.title)}}</h3>
      <h2>{{$t(info.description)}}</h2>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t("rank")}}
          </div>
          <div class="cell header">
            {{$t("sector.sector")}}
          </div>
          <div class="cell header">
            {{$t("tickets")}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(sector, index) in getItems">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{sector.key}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{sector.doc_count | getKNumber | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{sector.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Sector',
    components: {
      Info
    },
    props: {
      result: Object,
      search: Object
    },
    data() {
      return {
        fullscreen: false,
        info: {
         title: "sector.title",
         infoKey: "sector.info",
         description: "sector.description"
        },
      }
    },
    computed: {
      getItems() {
        if (this.result && this.result.aggregations && this.result.aggregations['to-bills'] && this.result.aggregations['to-bills'].bills && this.result.aggregations['to-bills'].bills.shopSector) {
          return this.result.aggregations['to-bills'].bills.shopSector.buckets
        }
        return []
      }
    },
    mounted() {
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/sector.sass"
</style>
